
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/checkout/upgrade-to-hardcopy",
      function () {
        return require("private-next-pages/checkout/upgrade-to-hardcopy/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/checkout/upgrade-to-hardcopy"])
      });
    }
  